var jade = require("/opt/atlassian/pipelines/agent/build/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"layout__item\"><div class=\"c-field\"><div ng-if=\"vm.logo.$ngfBlobUrl || vm.game.url\"><a ng-click=\"vm.showPreviewModal(vm.logo.$ngfBlobUrl || vm.game.display_url)\"><img ng-src=\"{{ vm.logo.$ngfBlobUrl || vm.game.display_url }}\" class=\"c-thumbnail\"/></a></div><div class=\"u-pt--\"><button ngf-drop=\"ture\" ngf-select=\"ture\" ngf-validate=\"\" ngf-change=\"vm.handleNewFile(vm.logo)\" ng-model=\"vm.logo\" ngf-max-size=\"'3MB'\" accept=\"image/*\" ngf-pattern=\"'image/*'\" class=\"c-uploader__input\">{{ 'uploadLogo' | translate }}<span gg-icon=\"icon-browse\" class=\"o-icon c-uploader__icon\"></span></button></div></div></div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/admin/games/gamesLogoUpload.jade
 ** module id = 635
 ** module chunks = 0
 **/